import validate from "/usr/src/app/content/n3-packages-a8eac06e-e6fd-4b63-858c-99ad387bb56e/b2c-build/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/usr/src/app/content/n3-packages-a8eac06e-e6fd-4b63-858c-99ad387bb56e/b2c-build/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {}